/**
 * Created by pmnia on 8/22/15.
 */


(function(){
    angular.module('app.widgets')
        .run(configHrefDirective)
        .service('hrefLangService', hrefLangService)
        .directive('obtHrefLang',obtHrefLang);

    /*@ngInject*/
    function hrefLangService(){
        var links = {};
        var vm = this;
        vm.setLinks = setLinks;
        vm.getLinks = getLinks;
        return vm;

        function getLinks(){
            return links;
        }
        function setLinks(newLinks){
            if(newLinks){
                links = newLinks;
            }
        }
    }
    /*@ngInject*/
    function configHrefDirective($rootScope, $state, hrefLangService){
        $rootScope.$on('$stateChangeSuccess',
            function(event, toState, toParams, fromState, fromParams){
                //var current_location = window.location;
                // window.location.hash
                var hrefLangs = {};
                var langs = ['fr','en'];
                var params = angular.extend({}, toParams);

                var lang;
                var absoluteLink;

                for(var i=0; i< langs.length; i++){
                    lang = langs[i];
                    params.language = lang;
                    absoluteLink = $state.href(toState, params, {absolute: true});
                    //var link ='<link rel="alternate" hreflang="' +
                    //    lang +'" href="'+ absoluteLink + '"/>';
                    hrefLangs[lang] = absoluteLink;
                }
                hrefLangService.setLinks(hrefLangs);
            });
    }
    function obtHrefLang(){
        return {
            restrict:'EA',
            replace:true,
            scope:{},
            template: '<link ng-repeat="(key, url) in vm.hrefLangService.getLinks()" rel="alternate" hreflang="{{key}}" href="{{ url }}" />',
            controller: /*@ngInject*/function(hrefLangService){
                var vm = this;
                vm.hrefLangService = hrefLangService;
            },
            controllerAs:'vm'
        };

    }

})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/hreflang.directive.js
 ** module id = 188
 ** module chunks = 0
 **/